import { useEffect } from "react";

const SITE = process.env.REACT_APP_SITE_URL || process.env.REACT_APP_BACKEND_URL || "";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function useSEO({ title, description, keywords, image, type = "website", path }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | MommysLiquidGold` : "MommysLiquidGold | Warm Support for Breastfeeding Mothers";
    document.title = fullTitle;

    const url = path ? `${SITE}${path}` : (typeof window !== "undefined" ? window.location.href : SITE);
    const kw = Array.isArray(keywords) ? keywords.join(", ") : keywords;
    const img = image || "https://images.pexels.com/photos/10956985/pexels-photo-10956985.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=630&w=1200";

    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", kw);

    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", img);

    upsertLink("canonical", url);
  }, [title, description, keywords, image, type, path]);
}
